var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-action mt-3 mr-1 ml-1",attrs:{"width":"30%","height":"100px"},on:{"click":_vm.action}},[_c('v-card-text',[_c('div',{staticClass:"ma-auto"},[_c('v-icon',{staticClass:"ma-2"},[_vm._v(_vm._s(_vm.icon))]),_c('p',{staticClass:"font-12 line-height-15"},[_vm._v(_vm._s(_vm.title))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }